import { z } from "zod";

const optional = () => z.string().optional().or(z.literal(""));

export const profileFormSchema = z.object({
  userid: z
    .string()
    .trim()
    .min(1, "User ID required")
    .max(40)
    .regex(/^[A-Za-z0-9._-]+$/, "Use letters, numbers, . _ -"),
  fname: z.string().trim().min(1, "First name required").max(60),
  lname: z.string().trim().min(1, "Last name required").max(60),
  email: optional(),
  phone: optional(),
  department_id: optional(),
  is_active: z.boolean(),
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;

export const emptyProfileForm: ProfileFormValues = {
  userid: "",
  fname: "",
  lname: "",
  email: "",
  phone: "",
  department_id: "",
  is_active: true,
};

export const userRolesFormSchema = z.object({
  role_ids: z.array(z.string().uuid()),
});

export type UserRolesFormValues = z.infer<typeof userRolesFormSchema>;
